export default __webpack_public_path__ + "static/media/Events.ae8c29a5.svg";